import { defineComponent, ref } from 'vue';
import HolidayTableComponent from '@/components/holidayTable/HolidayTable.vue';
import HolidayFormComponent from '@/components/holidayTable/holidayForm/HolidayForm.vue';

export default defineComponent({
  name: 'HolidayPage',
  components: {
    HolidayTableComponent,
    HolidayFormComponent,
  },
  setup: () => {
    const currentYear = new Date().getFullYear();
    const years = [
      { name: `พ.ศ. ${currentYear + 543}`, value: currentYear },
      { name: `พ.ศ. ${currentYear + 544}`, value: currentYear + 1 },
    ];
    const selectedYear = ref(currentYear);
    const holidayId = ref<number | null>(null);
    const holidayForm = ref<InstanceType<typeof HolidayFormComponent>>();

    const createClick = () => {
      Promise.resolve(holidayId.value = null)
        .then(() => holidayForm.value?.show());
    };

    const editClick = (id: number) => {
      Promise.resolve(holidayId.value = id)
        .then(() => holidayForm.value?.show());
    };

    return {
      years,
      selectedYear,
      holidayId,
      holidayForm,
      createClick,
      editClick,
    };
  }
});
